import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import nbNo from '../resources/HN.CoreFrontend.NPM.Packages.CMS.Video.nb-NO.json';
export const getResources = (language) => {
    switch (language) {
        case LanguageLocales.NORWEGIAN:
        default:
            return nbNo;
    }
};
